import React from 'react';
import './css/sidebar.css'
import logo from './img/kz-logo-full-400.png';
import { NavLink } from 'react-router-dom';

const Sidebar = props => {

    return (
        <div className="side-bar">

            <div className="side-bar-header">
                <a target="_blank" rel="noopener noreferrer" href="https://kanbanzone.com">
                    <img src={logo} alt="logo"/>
                </a>
            </div>
            <div className="side-bar-body">
                <h3>Documentation</h3>
                <div className="api-link"><NavLink className="inactive" activeClassName="active" to="/apiReference">API Reference</NavLink></div>
                <div className="api-link"><NavLink className="inactive" activeClassName="active" to="/webhooksReference">Webhooks</NavLink></div>
                <div className="api-link"><NavLink className="inactive" activeClassName="active" to="/zapierReference">Zapier</NavLink></div>
            </div>
        </div>
    )
}

export default Sidebar;